import { cn } from "@/lib/utils";

export function TenantChip({ name, color = "#0A2540", className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 px-2 py-1 text-xs font-medium bg-white border border-slate-200 rounded-sm",
        className
      )}
    >
      <span className="w-2 h-2 rounded-sm" style={{ background: color }} />
      <span className="text-slate-800">{name}</span>
    </span>
  );
}

const ROLE_STYLES = {
  platform_administrator: "bg-slate-900 text-white border-slate-900",
  tenant_administrator: "bg-slate-800 text-white border-slate-800",
  executive: "bg-altara-deep text-white border-altara-deep",
  compliance: "bg-emerald-50 text-emerald-800 border-emerald-200",
  conduct_risk: "bg-rose-50 text-rose-800 border-rose-200",
  customer_experience: "bg-sky-50 text-sky-800 border-sky-200",
  call_centre: "bg-amber-50 text-amber-800 border-amber-200",
  advisor: "bg-indigo-50 text-indigo-800 border-indigo-200",
  learning_administrator: "bg-teal-50 text-teal-800 border-teal-200",
  auditor: "bg-purple-50 text-purple-800 border-purple-200",
  read_only: "bg-slate-50 text-slate-600 border-slate-200",
  api_user: "bg-slate-100 text-slate-700 border-slate-200",
};

export function RoleChip({ role, className }) {
  const label = role.replace(/_/g, " ");
  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-0.5 text-[10px] uppercase tracking-[0.12em] font-medium border rounded-sm",
        ROLE_STYLES[role] || "bg-slate-50 text-slate-700 border-slate-200",
        className
      )}
    >
      {label}
    </span>
  );
}
